import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { IAppState } from '../../store/common/interfaces/app-state.interface';
import { ServersideAlertService } from './serverside-alert.service';
import { IOnboardingSummary } from '../../interfaces/onboarding/client/onboarding-summary';
import { IApiResponse } from '../../interfaces/api/api-response.interface';
import { catchError, firstValueFrom, map, throwError } from 'rxjs';
import { IOnboardingSummaryDetails } from '../../interfaces/onboarding/client/onboarding-summary-details';
import { Observable } from 'rxjs';
import { IClientCustomer } from '../../interfaces/onboarding/customer-portfolio/client-customer.interface';
import { IPageContent } from '../../interfaces/common/content/page-content.interface';
import { tap } from 'rxjs/operators';
import { IDocument } from '../../interfaces/common/document/document.interface';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private apiUrl = environment.apiUrl;
  private clientControllerSuffix = 'Onboarding/Onboarding/client/';
  private clientSummary: IOnboardingSummaryDetails;
  private onboardingSummary: IOnboardingSummary[];
  public customerDetails: IClientCustomer[];

  constructor(
    private httpClient: HttpClient,
    public ssas: ServersideAlertService,
    private store: Store<IAppState>
  ) { }

  async getOnboardingSummary(skip: number, pageSize: number, searchText: string): Promise<IOnboardingSummary[]> {
    const formData: any = new FormData();
    formData.append('Skip', skip);
    formData.append('Take', pageSize);
    formData.append('SearchText', searchText);
    const url = `${this.apiUrl}${this.clientControllerSuffix}onboarding-summary`;
    const result = await firstValueFrom(
      this.httpClient.post<IApiResponse>(url, formData)
    );

    if (result === null || result.data === null) this.onboardingSummary;
    else
      this.onboardingSummary =
        result.data as unknown as IOnboardingSummary[];

    return this.onboardingSummary;
  }

  async getOnboardingSummaryDetails(enrollmentId: string): Promise<IOnboardingSummaryDetails> {
    const url = `${this.apiUrl}${this.clientControllerSuffix}get-onboarding-summary-details/${enrollmentId}`;
    const response = await firstValueFrom(
      this.httpClient.get<IApiResponse>(url).pipe()
    );
    if (response.data == null) this.clientSummary;
    else {
      this.clientSummary = response.data as unknown as IOnboardingSummaryDetails;
    }
    this.clientSummary = response.data as IOnboardingSummaryDetails;

    this.customerDetails = response.data.customerGridResponse as IClientCustomer[];

    return this.clientSummary;
  }


  async getEnrollmentDocumentSummaryById(enrollmentId: string): Promise<IDocument[]> {
    const url = `${this.apiUrl}${this.clientControllerSuffix}onboardingSummary-documents/${enrollmentId}`;
    return firstValueFrom(
      this.httpClient.get<IApiResponse>(url).pipe(
        map((response) => response.data as IDocument[]),
        catchError((error: ErrorEvent) =>
          throwError(() => new Error(error.message))
        )
      )
    );
  }

  async getAllQuestion(): Promise<IPageContent[]> {
    const url = `${this.apiUrl}${this.clientControllerSuffix}get-all-question`;
    const response = await firstValueFrom(
      this.httpClient.get<IApiResponse>(url).pipe()
    );
    return response.data as unknown as IPageContent[];
  }

  getAllQuestionOb(): Observable<IPageContent[]> {
    const url = `${this.apiUrl}${this.clientControllerSuffix}get-all-question`;
    const response = this.httpClient.get<IPageContent[]>(url).pipe(
      tap(data => data),
    );
    return response
  }
}
